import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { of, Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';

@Component({
  selector: 'app-day-item-details',
  templateUrl: './day-item-details.component.html',
  styleUrls: ['./day-item-details.component.scss']
})
export class DayItemDetailsComponent implements OnInit {

  constructor(private activatedRoute: ActivatedRoute) { }

  data$: Observable<string>;

  ngOnInit() {
    this.data$ = this.activatedRoute.params.pipe(
      switchMap(p => of(`group: '${p.group}', key: '${p.key}'`))
    )
  }

}
